export default __webpack_public_path__ + "static/media/xec.90116c49.png";